// extracted by mini-css-extract-plugin
export default {"authHeader":"DeepHeader_authHeader_uyJzh"};